import { Fragment } from 'react'

const faqs = {
  'Foo Bar': 'Lorem ipsum...',
  'Foo Bar 2': 'Lorem ipsum...',
  'Foo Bar 3': 'Lorem ipsum...',
}

const FAQs = (props) => {
  return (
    <div className="px-4 py-20 bg-opacity-50 rounded bg-blue-300">
      <div className="flex flex-col max-w-6xl mx-auto md:flex-row">
        <h2 className="w-full mb-5 mr-8 text-3xl font-extrabold leading-9 md:w-1/3">
          Frequently-asked questions
        </h2>
        <dl className="w-full md:w-2/3">
          {Object.entries(faqs).map(([question, answer]) => (
            <Fragment key={question}>
              <dt className="mb-4">
                <h3 className="text-xl font-semibold">{question}</h3>
              </dt>
              <dd className="mb-16">
                <p>{answer}</p>
              </dd>
            </Fragment>
          ))}
        </dl>
      </div>
    </div>
  )
}

export default FAQs
